<template>
  <div>
    <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
    <b-row class="mx-0 pb-5 border-bottom">
      <b-col class="col-12 col-md-4 text-center">
        <div class="d-flex">
          <div class="d-flex flex-column">
            <div
              style="width: 80px; cursor: pointer; max-height: 110px;"
              class="flex-fill m-1"
              v-if="images[1]"
              @click="bookData.imgCover = $store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_1'"
            >
              <img :src="$store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_1'" style="width: 100%; height: 100%;" />
            </div>
            <div
              style="width: 80px; cursor: pointer; max-height: 110px;"
              class="flex-fill m-1"
              v-if="images[2]"
              @click="bookData.imgCover = $store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_2'"
            >
              <img :src="$store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_2'" style="width: 100%; height: 100%;" />
            </div>
            <div
              style="width: 80px; cursor: pointer; max-height: 110px;"
              class="flex-fill m-1"
              v-if="images[3]"
              @click="bookData.imgCover = $store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_3'"
            >
              <img :src="$store.state.user.siteData.location +
                'repository/books/' +
                $route.params.id +
                '_3'" style="width: 100%; height: 100%;" />
            </div>
          </div>

          <div style="position: relative;">
            <transition name="fade">
              <div
                v-if="onFavs"
                style="
      position: absolute;
      z-index: 10;
      right: -2px;
      top: 50px;
      width: 35%;
      filter: drop-shadow(2px 4px .25rem rgba(0,0,0,.5));"
              >
                <img src="@/assets/favorite.svg" />
              </div>
            </transition>
            <img :src="bookData.imgCover" style="max-width: 100%;" />
            <img
              v-if="bookData.bookPrices[typeSel].promo"
              :src="$store.state.user.siteData.location +
                'repository/promos/' + bookData.bookPrices[typeSel].promo" 
              style="
                position: absolute;
                top: 0px;
                left: 0px;
                max-width: 100%;"      
              />
          </div>
        </div>
        <b-button
          class="mt-2 btn-text btn-block"
          variant="light"
          v-if="!onFavs"
          @click="addToFav()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="heart"
            class="svg-inline--fa fa-heart fa-w-16"
            role="img"
            viewBox="0 0 512 512"
            width="1em"
            height="1em"
          >
            <path
              fill="currentColor"
              d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
            />
          </svg>
          Agregar a favoritos
        </b-button>
        <b-button
          class="mt-2 btn-text btn-block"
          v-if="onFavs"
          @click="removeFromFav()"
        >
          <font-awesome-icon icon="heart" class="mr-1" />Quitar de favoritos
        </b-button>
      </b-col>
      <b-col
        class="col-12 col-md-4 d-flex flex-column justify-content-between"
        style="font-family: 'Poppins', sans-serif;"
      >
        <div>
          <div
            style="font-weight: bolder; font-size: x-large; line-height: 1.1; margin-bottom: 10px;"
          >
            {{ bookData.bookTitle }}
          </div>
          <div
            style="font-family: 'Poppins', sans-serif; font-size: large; line-height: 1.5rem;"
          >
            {{ bookData.bookSubtitle }}
          </div>
          <div class="py-2 text-muted">{{ bookData.bookDesc }}</div>
        </div>
        <div
          style="font-size: small; font-family: 'Nunito Sans', sans-serif; line-height: 1.7;"
        >
          <div v-if="bookProps.publisher">
            <b>Editorial:</b> {{ bookProps.publisher }}
          </div>
          <div v-if="bookProps.category">
            <b>Temática:</b> {{ bookProps.fullcategory }}
          </div>
          <div v-if="bookProps.collection">
            <b>Colección:</b> {{ bookProps.collection }}
          </div>
          <div v-if="bookProps.ISBN">
            <b>ISBN:</b> {{ bookProps.ISBN }}
          </div>
          <div v-if="bookProps.pages">
            <b>Número de páginas:</b> {{ bookProps.pages }}
          </div>
          <div v-if="bookProps.dateedition">
            <b>Año y mes de edición:</b> {{ bookProps.dateedition }}
          </div>
          <div v-if="bookProps.format">
            <b>Formato:</b> {{ bookProps.format }}
          </div>
        </div>
      </b-col>
      <b-col class="col-12 col-md-4">
        <div
          class="d-flex flex-column justify-content-between p-4 text-center"
          style="background: #F1F1F1; font-family: 'Poppins', sans-serif; border-radius: 2rem; min-height: 100%;"
        >
          <div style="font-weight: bolder; font-size: large;">Lo quiero</div>
          <b-form-radio-group id="radio-group-2" v-model="typeSel">
            <template v-for="(value, family) in bookData.bookPrices" >
              <div
                class="d-flex justify-content-between align-items-center p-2 border-bottom"
                :key="family"
                v-if="value.active === '1'"
              >
                <div style="width:40%; text-align: left; font-weight: 200;">
                  <span v-if="family === '1'">
                    Tapa blanda 
                  </span>
                  <span v-else-if="family === '2'">
                    Tapa dura 
                  </span>
                  <span v-else>
                    E-book 
                  </span>
                </div>
                <div v-if="getBooksByType(parseInt(family)) > 0" style="color: rgba(0,0,0,.7);">
                  <div
                    style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
                  >
                    {{ getBooksByType(parseInt(family)) }}
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    width="1rem"
                    height="1rem"
                  >
                    <path
                      id="svg_1"
                      fill="none"
                      d="m0,0l24,0l0,24l-24,0l0,-24z"
                    />
                    <path
                      id="svg_2"
                      d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
                    />
                  </svg>
                </div>

                <b-form-radio :value="family" />
              </div>
            </template>
            <template v-if="ebooks.length > 0" >
              <div
                class="d-flex justify-content-between align-items-center p-2 border-bottom"
                :key="4"
              >
                <div style="width:40%; text-align: left; font-weight: 200;">
                  E-book
                </div>

                <b-form-radio :value="4" />
              </div>
            </template>
          </b-form-radio-group>
          <template v-if="typeSel != 4">
            <div v-if="bookData.bookPrices[typeSel].stock > 0">
              <div class="my-3">
                <b-input-group style="margin-left: 30%; width: 40%;">
                  <b-input-group-prepend>
                    <b-button @click="removeItem()">-</b-button>
                  </b-input-group-prepend>

                  <b-form-input
                    class="text-center bg-secondary text-white"
                    style="padding:0px; border-color: #6c757d;"
                    disabled
                    :value="onCart"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button @click="addItem()">+</b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-link style="color: black; font-size: 14px;" v-b-toggle.sidebar-cart
                  >Ver carrito</b-link
                >
              </div>
              <div style="color: #62A202; font-size: small; font-weight: bold;">
                En Stock
              </div>
              <div style="font-size: xx-large; font-weight: bolder;">
                ${{ subtotal > 0 ? subtotal : cost }}
              </div>
              <div style="font-size: small;" v-if="subtotal > 0">
                ${{ cost }} x {{ onCart }}
              </div>
            </div>
            <div v-else>
              <div class="text-danger mt-3" style="font-size: small; font-weight: bold;">
                Sin Stock
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="d-flex justify-content-between align-items-center p-2"
              v-for="(ebook, eindex) in ebooks"
              :key="'ebook-' + eindex"
            >
              <div style="text-align: left; font-weight: 200; padding-left: 1rem;">
                {{ ebook.name }}
              </div>
              <b-button
                variant="outline-secondary"
                class="border-0"
                :href="ebook.link"
                target="_blank"
              >
                <!--<b-icon icon="box-arrow-up-right" />-->
                <b-icon icon="arrow-right" />
              </b-button>
            </div>
          </template>
        </div>
      </b-col>
    </b-row>
    <b-row class="mx-0 pb-5 border-bottom">
      <b-col class="col-12 col-md-8">
        <main-title title="Sinopsis" />
        <div
          style="font-size: small; overflow: auto; max-height: 270px; padding:0.25rem 1rem 0.25rem 0px; font-weight: 300;"
        >
          <span v-html="bookData.bookResume"></span>
        </div>
      </b-col>
      <b-col class="col-12 col-md-4">
        <main-title title="Leer un fragmento" />
        <div
          class="d-flex flex-column justify-content-center p-4"
          style="background: #F1F1F1; font-family: 'Poppins', sans-serif; border-radius: 2rem; /*min-height: 270px;*/ font-weight: 200;"
        >
          <b-list-group flush>
            <b-list-group-item
              class="d-flex justify-content-between"
              style="background-color: transparent;"
              v-for="document in documents" :key="document.id"
            >
              {{document.name}}
              <b-button
                variant="outline-secondary"
                class="border-0"
                v-b-tooltip.hover
                title="Descargar"
                @click="download(document);"
              >
                <b-icon icon="download" />
              </b-button>
            </b-list-group-item>

            <!--<b-list-group-item
              class="d-flex justify-content-between"
              style="background-color: transparent;"
            >
              Índice
              <b-button
                variant="outline-secondary"
                class="border-0"
                v-b-tooltip.hover
                title="Descargar"
              >
                <b-icon icon="download" />
              </b-button>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between"
              style="background-color: transparent;"
            >
              Fragmento
              <b-button
                variant="outline-secondary"
                class="border-0"
                v-b-tooltip.hover
                title="Descargar"
              >
                <b-icon icon="download" />
              </b-button>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between"
              style="background-color: transparent;"
            >
              Tapa
              <b-button
                variant="outline-secondary"
                class="border-0"
                v-b-tooltip.hover
                title="Descargar"
              >
                <b-icon icon="download" />
              </b-button>
            </b-list-group-item>-->
          </b-list-group>
        </div>
      </b-col>
    </b-row>
    <main-title :title="authorTitle" />
    <div class="d-flex align-items-center mb-4" v-for="(item, index) in authorNames" :key="index">
      <b-avatar class="d-none d-md-inline-flex" size="150px" :src="$store.state.user.siteData.location +
                'repository/authors/' + bookData.authorIds[index]  + '_small'" />
      <div
        class="ml-5"
        style="flex-shrink: 100; font-size: small; font-weight: 300;"
      >
        <div
          style="font-size: larger; color: #e8661a; font-family: 'Poppins', sans-serif; font-weight: 500; margin-bottom: 1rem; cursor: pointer;"
          @click="viewAuthor(bookData.authorIds[index])"
        >
          {{item}}
        </div>
        <span v-html="authorBios[index]"></span>        
      </div>
    </div>
    

    <main-title :title="relatedAuthorTitle" />
    <book-list :items="relatedAuthorBooks" @selbook="updateData()" />
    <main-title :title="'Otros libros de ' + bookProps.category" />
    <book-list :items="relatedCategoryBooks" @selbook="updateData()" />
    <!--
    <main-title title="Notas relacionadas" />
    <div class="d-flex" style="margin: 0px -1rem;">
      <small-news></small-news>
      <small-news></small-news>
      <small-news></small-news>
    </div>
    -->
  </div>
</template>
<script>
import { mapActions } from "vuex";
import MainTitle from "@/components/MainTitle.vue";
import BookList from "@/components/BookList.vue";
import SmallNews from "@/components/Noticias/Small.vue";
import axios from "axios";

export default {
  components: {
    MainTitle,
    BookList,
    SmallNews
  },
  data: function() {
    return {
      breadcrumb: [
        {
          text: "Libreria",
          to: { name: "Libreria" }
        },
        {
          text: "Categoría",
          to: { name: "Libreria" }
        },
        {
          text: "Comunicación y periodismo",
          active: true
        }
      ],
      typeSel: "1",
      cost: 700,
      subtotal: 0,
      bookData: {},
      bookProps:{
        publisher: '',
        collection: '',
        category: '',
        ISBN: '',
        pages: '',
        dateedition: '',
        format: ''
      },
      documents: [],
      images: [
        false,
        false,
        false,
        false
      ],
      authorTitle: 'Sobre los autores',
      relatedAuthorTitle: 'Otros libros de los autores',
      relatedAuthorBooks: [],
      relatedCategoryBooks: [],
      authorBios: [],
      authorNames: [],
      ebooks: []
    };
  },
  mounted(){
    this.updateBookInfo();
    this.getDocuments();
  },
  computed: {
    onFavs: function() {
      const favBookIndex = this.$store.getters.getFavItemById(
        this.bookData.bookId
      );
      if (favBookIndex === 0) {
        return false;
      } else {
        return true;
      }
    },
    /*
    bookData: function() {
      return {
        imgCover: "img/7.png",
        bookTitle: "Comunicación y periodismo",
        bookDesc: "Sivana Comba y Edgardo Toledo",
        bookId: parseInt(this.$route.params.id),
        size: 25
      };
    },
    */
    onCart: function() {
      return this.$store.getters.getItemByType({
        id: this.bookData.bookId,
        type: parseInt(this.typeSel)
      });
    },
    demo: function() {
      const result = [];
      for (let page = 0; page < 2; page++) {
        for (let bookData = 1; bookData < 5; bookData++) {
          result.push({
            imgCover: "img/7.png",
            bookTitle: "Comunicación y periodismo",
            bookDesc: "Sivana Comba y Edgardo Toledo",
            bookId: bookData + page * 4,
            size: 25
          });
        }
      }
      return result;
    }
  },
  watch: {
    typeSel: function(newValue, oldValue) {
      
      this.cost = parseInt(this.bookData.bookPrices[newValue].price);
      this.bookProps.ISBN = this.bookData.bookProperties[newValue].ISBN;
      this.bookProps.pages = this.bookData.bookProperties[newValue].Paginas;
      this.bookProps.dateedition = this.bookData.bookProperties[newValue]['Fecha edicion'];
      this.bookProps.format = this.bookData.bookProperties[newValue].Formato;

      if (this.onCart > 0) {
        this.subtotal = this.onCart * this.cost;
      }
    },
    onCart: function(newValue, oldValue) {
      this.subtotal = newValue * this.cost;
    }
  },
  created: function() {
    if (this.onCart > 0) {
      this.subtotal = this.onCart * this.cost;
    }
  },
  methods: {
    updateData(){
      console.log('Actualizar');
      this.updateBookInfo();
      this.getDocuments();
    },
    async updateBookInfo(){
      console.log(this.$store.state.user.siteData);

      await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getDetails",
          JSON.stringify( {id: this.$route.params.id } ),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          let result = {};
          evtResponse.data.records.forEach(element => {
            result = {
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: element.subtitle,
              bookPrices: element.price,
              bookProperties: element.props,
              authorIds: element.authorIds.split(','),
              category_ids: element.category_ids.split(','),
              size: 25
            };
            this.authorBios = element.authorBio;
            this.authorNames = element.author.split(', ');
            const categories = element.category_name.split(', ');
            let categoryName = element.category_name
            let categoryTitle = element.category_name
            if (categories.length > 2) {
              categoryName = categories[0] + ', ' + categories[1] + ',...' 
              categoryTitle = 'las mismas categorías'
            }
            this.breadcrumb[2].text = categoryName;
            this.bookProps.publisher = element.publisher_name;
            this.bookProps.collection = element.collection_name;
            this.bookProps.category = categoryTitle;
            this.bookProps.fullcategory = element.category_name;

            for(let p=1; p < 4; p ++){
              if (element.price[p].active === '1'){
                this.cost = parseInt(element.price[p].price);
                this.bookProps.ISBN = element.props[p].ISBN;
                this.bookProps.pages = element.props[p].Paginas;
                this.bookProps.dateedition = element.props[p]['Fecha edicion'];
                this.bookProps.format = element.props[p].Formato;

                break;
              }
            }
            this.ebooks = element.ebooks
          });
          this.bookData = result;

          this.getBookImages(1);
          this.getRelatedBooks();

          
        });
    },
    async getDocuments(){
      console.log(this.$store.state.user.siteData);

      this.documents = await axios
        .post(
          this.$store.state.user.siteData.location + "documents/documents/find",
          JSON.stringify( {entitytype: 'items', entityid: this.$route.params.id } ),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push( {
              name: element.name,
              id: element.id,
              downloable: element.downloable
            });
            
          });
          return result;
        });
    },
    download(document) {
      window.open(
        this.$store.state.user.siteData.location + 'repository/documents/' + document.id
      )
    },
    async getRelatedBooks(){
      
      this.relatedAuthorBooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForStore",
          JSON.stringify({ page: 1, author: this.bookData.authorIds }),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: element.subtitle,
              bookPrice: parseInt(element.price),
              regularCost: parseInt(element.regularcost),
              bookStock: parseInt(element.stock),
              size: 33,
              promo: element.promo
            });
          });
          return result;
        });
      this.relatedCategoryBooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForStore",
          JSON.stringify({ page: 1, category: this.bookData.category_ids }),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            result.push({
              imgCover:
                this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookResume: element.resume,
              bookSubtitle: element.subtitle,
              bookPrice: parseInt(element.price),
              regularCost: parseInt(element.regularcost),
              bookStock: parseInt(element.stock),
              size: 33,
              promo: element.promo
            });
          });
          return result;
        });
    },
    getBookImages: function(image){
      const imgRepo = this.$store.state.user.siteData.location +
                'repository/books/' +
                this.$route.params.id  +
                '_' + image;
      const tmpimg = new Image();
      tmpimg.onload = function(){
        this.images[image] = true;
        this.images = this.images.slice(0);

        if (image < 3){
          console.log('Load ' + (image + 1) +' on load');
          this.getBookImages(image + 1);
        }
      }.bind(this);
      tmpimg.onerror = function(){
        if (image < 3){
          console.log('Load ' + (image + 1) +' on error');
          this.getBookImages(image + 1);
        }
      }.bind(this);
      tmpimg.src = imgRepo;

    },
    getBooksByType: function(type) {
      return this.$store.getters.getItemByType({
        id: this.bookData.bookId,
        type: type
      });
    },
    addToFav: function() {
      this.addFavItem(this.bookData.bookId);
    },
    removeFromFav: function() {
      this.removeFavItem(this.bookData.bookId);
    },
    addItem: function() {
      this.addCartItem({
        id: this.bookData.bookId,
        type: parseInt(this.typeSel)
      });
    },
    removeItem: function() {
      this.removeCartItem({
        id: this.bookData.bookId,
        type: parseInt(this.typeSel)
      });
    },
    viewAuthor(autorId){
      this.$router.push({name: 'AutoresDetail', params: {id: autorId} });
    },
    ...mapActions([
      "addCartItem",
      "removeCartItem",
      "addFavItem",
      "removeFavItem"
    ])
  }
};
</script>
